import type { Routes } from '@angular/router';
import { MapPageComponent } from './map-page.component';

export const mapRoutes: Routes = [
  { path: '', component: MapPageComponent },
  { path: ':x/:y/:z', component: MapPageComponent },
];
